import { useBaseApiCall } from '@/api/factory/base/api';
import { useHandleMutationError } from '@/api/utils';
import type { JWTToken } from '@/hooks/use-customer';
import { ga4_login } from '@/libs/ga4/actions/login';
import type { CustomerType } from '@/types/storage';
import { useMutation } from '@tanstack/react-query';
import { jwtDecode } from 'jwt-decode';

type LoginUserMutationData = {
  token: string;
  customerType: CustomerType;
};

type LoginUserDTO = {
  email: string;
  password: string;
};

export const useLoginUserMutation = () => {
  const mutationFn = useBaseApiCall<LoginUserMutationData, [LoginUserDTO]>(
    (api, data) => api.post(`customers/login`, data),
  );
  const handleMutationError = useHandleMutationError();

  return useMutation({
    mutationFn,
    onSuccess: ({ token }) => {
      const { data } = jwtDecode<JWTToken>(token);
      ga4_login({ user_id: data.user_id, method: 'form' });
    },
    onError: handleMutationError,
  });
};
